import * as React from "react";
import { height, minZoomScale, width } from "./zoom-container";

const dotsId = "dots";

export function AxesAndBounds() {
  const length = 1000000;
  return (
    <g>
      <g id="axes">
        <line x1={-length} x2={length} y={0} stroke="black" strokeWidth={2} />
        <line y1={-length} y2={length} x={0} stroke="black" strokeWidth={2} />
      </g>
      <g id="bound">
        <line x={width} y1={0} y2={height} stroke="red" strokeWidth={2} />
        <line y={height} x1={0} x2={width} stroke="red" strokeWidth={2} />
      </g>
    </g>
  );
}

export function Defs() {
  return (
    <defs>
      <pattern
        id="dots"
        patternUnits="userSpaceOnUse"
        width="20"
        height="20"
        // patternTransform="scale(1) rotate(0)"
      >
        <circle r={1} cx={1} cy={2} fill="hsl(261, 60%, 38%)" stroke="none" />
      </pattern>
      <filter id="shadow" colorInterpolationFilters="sRGB">
        <feDropShadow dx={2} dy={2} stdDeviation={4} floodOpacity={0.25} />
      </filter>

      <filter id="shadow2" colorInterpolationFilters="sRGB">
        <feDropShadow dx={2} dy={2} stdDeviation={2.5} floodOpacity={0.5} />
      </filter>

      <filter id="text-shadow" colorInterpolationFilters="sRGB">
        <feDropShadow dx={3} dy={3} stdDeviation={2} floodOpacity={0.4} />
      </filter>

      {/* <filter
        id="minimapDropShadow"
        x="-20%"
        y="-20%"
        width="150%"
        height="150%"
      >
        <feOffset result="offOut" in="SourceGraphic" dx="1" dy="1"></feOffset>
        <feColorMatrix
          result="matrixOut"
          in="offOut"
          type="matrix"
          values="0.1 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0 0 0 0 0.5 0"
        ></feColorMatrix>
        <feGaussianBlur
          result="blurOut"
          in="matrixOut"
          stdDeviation="10"
        ></feGaussianBlur>
        <feBlend in="SourceGraphic" in2="blurOut" mode="normal"></feBlend>
      </filter> */}
    </defs>
  );
}

export function BackgroundGrid() {
  // const bgPercentage = (2 / minZoomScale) * 100;

  return (
    <rect
      x={-width}
      y={-height}
      width={width * 3}
      height={height * 3}
      // y={`${-bgPercentage}%`}
      // width={`${bgPercentage}%`}
      // height={`${bgPercentage * 2}%`}
      fill={`url(#${dotsId})`}
    />
  );
}
